import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Make sure Bootstrap is installed
import { MdOutlineAdd, MdOutlineDelete, MdOutlineEdit } from 'react-icons/md';
import { Breadcrumb, BreadcrumbItem, Modal } from 'reactstrap';
import { useNavigate } from 'react-router';
import { t } from 'i18next';
import i18n from 'src/i18n';
import "./question.css"
import { toast } from 'react-toastify';
import { fetchDataApi, deleteQuestionApi } from 'src/services/question';
import { getUserRolePermissions } from 'src/services/userServicer';
import { getReferences } from 'src/services/reference';
import { fetchAllCategoryDataApi } from 'src/services/riskServices';
interface Question {
  id: string;
  question_en: string;
  question_ar: string;
  reference_id: string;
  category: { name: string };
  risks: { risk: { name: string } }[];
  controls: { control: { description: string } }[];
}


const QuestionTable = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [questions, setQuestions] = useState<Question[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [selectedQuestionId, setSelectedQuestionId] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [userPermissions, setUserPermissions] = useState<any>(null);
  const [notAllowed, setNotAllowed] = useState(false);
  const [references, setReferences] = useState<any[]>([]);
  const [categoryId, setCategoryId] = useState<string | null>(null);
const [referenceId, setReferenceId] = useState<string | null>(null);

const [categories, setCategories] = useState<any[]>([]); // State for categories
const [selectedCategoryId, setSelectedCategoryId] = useState(''); // Track selected category
const [selectedReferenceId, setSelectedReferenceId] = useState('');


const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");


useEffect(() => {
  const delaySearch = setTimeout(() => {
    setDebouncedSearchTerm(searchTerm);
  }, 500); // Adjust delay (500ms)

  return () => clearTimeout(delaySearch); // Clear timeout on every new keystroke
}, [searchTerm]);






const fetchCategories = async () => {
  try {
    const response = await fetchAllCategoryDataApi();
    if (response.success && Array.isArray(response.data)) {
      setCategories(response.data);;
    } else {
      throw new Error("Invalid data format for categories");
    }
  } catch (error) {
    toast.error(t("Failed to fetch categories"));
   
  }
};
 

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Fetch questions
  const fetchQuestions = async () => {
    setLoading(true);
    try {
      const data = await fetchDataApi(
        `bank-questions?perPage=${pageSize}&pageNo=${page}&categoryId=${selectedCategoryId}&referenceId=${selectedReferenceId}&search=${debouncedSearchTerm}`
      );
      if (data.success) {
        setQuestions(data.data);
        setTotalPages(data.totalPages);
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      setError(true);
      setErrorMsg(error.message || "An error occurred while fetching data.");
    }
  };
  // Fetch references
  const fetchReferences = async () => {
    try {
      const data = await getReferences('', 500, 0);
      if (data && data.success) {
        setReferences(data.data); // Store references in state
      } else {
        toast.error(data[0].message, { autoClose: 5000, className: 'toast-error' });
      }
    } catch (error: any) {
      toast.error(error, { autoClose: 5000, className: 'toast-error' });
      console.error('Error fetching references:', error);
    }
  };

  // Get reference name by ID
  const getReferenceNameById = (referenceId: string) => {
    const reference = references.find((ref) => ref.id === referenceId);
    return reference ? reference.name : ""; // Return "N/A" if reference is not found
  };

  useEffect(() => {
    const fetchUserRolePermissions = async () => {
      try {
        //let userId: any = localStorage.getItem('userId');
        const permissions = await getUserRolePermissions();
        if (permissions.success) {
          const compliancePagePermission = permissions.data.permissions.find((permission: any) => permission.page === "survey");
          if (compliancePagePermission) {
            setUserPermissions(compliancePagePermission);
            if (compliancePagePermission.permissions.show) {
              setNotAllowed(false);
              fetchQuestions();
              fetchReferences(); // Fetch references when permissions are loaded
            } else {
              setNotAllowed(true);
            }
          } else {
            toast.error(permissions.message);
          }
        }
      } catch (error: any) {
        toast.error(t("permissions.Error_fetching_user_role_permissions") + ":", error);
      }
    };

    fetchUserRolePermissions();
    fetchCategories();
 
      
    }, []);
  
    useEffect(() => {
      fetchQuestions(); 
    }, [page, pageSize,  selectedCategoryId, selectedReferenceId]); // Remove extra fetch calls inside permission fetching
    

  const confirmDelete = (id: string) => {
    setSelectedQuestionId(id);
    toggleModal();
  };

  const handleDelete = async () => {
    if (selectedQuestionId !== null) {
      try {
        await deleteQuestionApi(selectedQuestionId);
        setQuestions((prevQuestions: any) => prevQuestions.filter((question: any) => question.id !== selectedQuestionId));
        toggleModal();
        toast.success(t("Question deleted successfully"));
      } catch (error: any) {
        alert(error.message || "An error occurred while deleting the question.");
      }
    }
  };

  const filteredQuestions = questions.filter((q) => {
    const referenceName = getReferenceNameById(q.reference_id).toLowerCase();
    return (
      referenceName.includes(searchTerm.toLowerCase()) ||  // Search by reference name
      q.category.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      q.question_en?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      q.question_ar?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });
  

  return (
    <div className="root">
      <Breadcrumb>
        <BreadcrumbItem>{t("header.you_are_here")}</BreadcrumbItem>
        <BreadcrumbItem active style={{ paddingRight: '10px' }}>{t("Question Catalog")}</BreadcrumbItem>
      </Breadcrumb>
      <h5 className="mb-lg">{t("Question Catalog")}</h5>
      {loading ? (
        <div className="loading">{t("Loading...")}</div>
      ) : (
        !notAllowed &&
        <>
          <div className="container_info" style={{ padding: '40px 20px', backgroundColor: 'var(--widget-bg)' }}>
            <div className="d-flex justify-content-between my-2">
            <input
        type="text"
        placeholder="Search by reference or category..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="border p-2 rounded  mb-4 w-25 "
      />

              {userPermissions?.permissions?.create && <button className="submit-button4" onClick={() => navigate('/createQuestion')}>
                <MdOutlineAdd size={20} /> {t("Create")}
              </button>}
            </div>
            <table className="styled-table">
              <thead className="table-dark">
                <tr>
                  <th style={{ width: '30%' }}>{t("Question")}</th>
                  <th style={{ width: '10%' }}>{t("Category")}</th>
                  <th style={{ width: '10%' }}>{t("Reference")}</th>
                  <th style={{ width: '20%' }}>{t("Risk")}</th>
                  <th style={{ width: '20%' }}>{t("Control")}</th>
                  <th style={{ width: '10%' }}>{t("Type")}</th>
                  <th>{t("actions")}</th>
                </tr>
              </thead>
              {filteredQuestions.length > 0 && <tbody>
                {filteredQuestions.map((item: any) => (
                  <tr key={item.id}>
                    <td>{i18n.language === 'ar' ? item.question_ar : item.question_en}</td>
                    <td>{item?.category?.name}</td>
                    <td>{getReferenceNameById(item.reference_id)}</td> {/* Display reference name */}
                    <td>{item?.risks?.map((risk: any) => risk?.risk?.name).join(", ")}</td>
                    <td>{item?.controls?.map((control: any) => control?.control?.description).join(", ")}</td>
                    <td>
                      <span className="badge" style={{ backgroundColor: '#4cc6dd' }}>
                        {item.question_type === 'textarea' && t("Text")}
                        {item.question_type === 'multiple_choice' && t("Multiple Choice")}
                        {item.question_type === 'single_choice' && t("Single Choice")}
                        {item.question_type === 'compliance_related' && t("Related to compliance")}
                        {item.question_type === 'risk_related' && t("Related to risk")}
                      </span>
                    </td>
                    <td>
                      <div className='d-flex'>
                        {userPermissions?.permissions.edit && <button className="action-button" onClick={() => navigate(`/updateQuestion/${item.id}`)}>
                          <MdOutlineEdit size={20} />
                        </button>}
                        {userPermissions?.permissions.delete && <button className="action-button-danger" onClick={() => confirmDelete(item.id)}>
                          <MdOutlineDelete size={20} />
                        </button>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>}
              {questions.length === 0 && <tbody>
                <tr>
                  <td colSpan={7} className="text-center alert alert-warning">
                    {t("No questions found")}
                  </td>
                </tr>
              </tbody>}
            </table>
          </div>

          {questions.length > 0 && <div className="pagination-controls mt-5">
            <button className="btn btn-warning btn-sm text-white" onClick={() => setPage(1)} disabled={page === 1}>
              {"<<"}
            </button>{" "}
            <button className="btn btn-warning btn-sm text-white" onClick={() => setPage((prev) => Math.max(prev - 1, 1))} disabled={page === 1}>
              {"<"}
            </button>{" "}
            <button className="btn btn-warning btn-sm text-white" onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))} disabled={page >= totalPages}>
              {">"}
            </button>{" "}
            <button className="btn btn-warning btn-sm text-white" onClick={() => setPage(totalPages)} disabled={page >= totalPages}>
              {">>"}
            </button>{" "}
            <span>
              {t("page")} {page} {t("to")} {totalPages}
            </span>
          </div>}

          <Modal className="p-5" isOpen={isModalOpen} toggle={toggleModal} title={String(t("Confirm Deletion") || "Confirm Deletion")}>
            <p id="delete-modal-description" className="m-3">
              {t("Are you sure you want to delete this question? This action cannot be undone.")}
            </p>
            <div className="d-flex justify-content-end gap-2 p-3">
              <button className="btn btn-outline-secondary" onClick={toggleModal} aria-label={t("Cancel") || "Cancel"}>
                {t("Cancel") || "Cancel"}
              </button>
              <button className="btn btn-danger" onClick={handleDelete} aria-label={t("Delete") || "Delete"}>
                <i className="bi bi-trash-fill me-2"></i>
                {t("Delete") || "Delete"}
              </button>
            </div>
          </Modal>
        </>
      )}
      {notAllowed && (
        <div className="container_info">
          <div className="d-flex justify-content-between my-2 text-center alert alert-danger">
            <h5 style={{ width: '100%' }} className="text-center">{t("You do not have permission to create questions.")}</h5>
          </div>
        </div>
      )}
    </div>
  );
};

export default QuestionTable;